import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilegrantLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	"xmlns:serif": "http://www.serif.com/",
	xmlns: "http://www.w3.org/2000/svg",
	width: "100%",
	height: "100%",
	viewBox: "0 0 446 383",
	xmlSpace: "preserve",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5
	},
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			id: "Tavola-da-disegno1",
			"serif:id": "Tavola da disegno1",
			x: 0,
			y: 0,
			width: 445.936,
			height: 382.68,
			style: { fill: "none" }
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "_clip1",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 0,
				y: 0,
				width: 445.936,
				height: 382.68
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#_clip1)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M63.804,196.801c24.911,13.176 55.468,20.154 89.003,19.094c47.609,-1.504 79.338,-15.658 96.767,-26.389c4.704,13.912 1.136,32.833 -2.592,52.852c-4.215,22.63 -16.87,50.102 -20.956,61.945c-2.155,6.249 -5.607,14.028 -8.569,22.001c-5.565,13.219 -11.342,28.463 -15.296,42.539c-1.097,3.908 -2.308,8.619 -3.574,13.988l-39.188,-0c-52.76,-0 -95.595,-42.835 -95.595,-95.595l0,-90.435Z",
					style: { fill: "url(#_Linear2)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M445.475,84.582c0.478,3.762 0.709,7.586 0.709,11.464l0,191.19c0,52.76 -42.834,95.595 -95.595,95.595l-36.424,-0c-2.561,-3.326 -4.201,-7.495 -5.035,-15.359c-3.444,-32.486 16.433,-83.406 19.479,-94.577c1.665,-6.103 6.996,-23.478 10.429,-40.867c3.671,-18.596 2.663,-43.519 -3.832,-57.674c-5.142,-11.207 -11.198,-18.67 -16.29,-23.483c0.659,0.132 1.367,0.267 2.122,0.402l0.326,0.058c16.036,2.857 52.347,5.521 86.085,-21.637c19.037,-15.325 30.817,-30.944 38.026,-45.112Z",
					style: {
						fill: "url(#_Linear3)",
						stroke: "#0068b4",
						strokeWidth: "0.6px"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M204.714,0.451c-5.104,16.554 -6.297,40.088 4.955,71.844c-0,0 15.527,46.142 57.789,63.251c-38.645,-2.812 -137.575,-9.59 -203.506,-14.078l-0.148,-0.01l0,-25.412c0,-52.761 42.835,-95.595 95.595,-95.595l45.315,-0Z",
					style: { fill: "url(#_Linear4)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M239.628,0.451l110.961,-0c33.472,-0 62.948,17.239 80.009,43.33c-42.513,24.286 -110.254,68.621 -138.63,87.372c-4.279,-12.63 -16.833,-48.741 -32.317,-84.703c-7.539,-17.511 -14.427,-33.295 -20.023,-45.999Z",
					style: { fill: "url(#_Linear5)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M63.389,196.583c-8.705,-4.6 -16.705,-9.974 -23.902,-16.022l-0.464,-0.39c-19.573,-16.546 -33.147,-38.101 -38.449,-63.028l63.378,4.325c65.931,4.488 164.861,11.266 203.506,14.078c-42.262,-17.109 -57.789,-63.251 -57.789,-63.251c-11.252,-31.756 -10.059,-55.29 -4.955,-71.844l34.914,-0c5.598,12.708 12.485,28.49 20.023,45.999c15.484,35.962 28.038,72.073 32.317,84.703c28.376,-18.751 96.117,-63.086 138.63,-87.372l1.739,2.711c0.767,1.334 1.535,2.669 2.303,4.003l1.917,3.741l-0.769,0.553l0.769,-0.552c4.573,9.361 7.655,19.577 8.918,30.345c-7.209,14.168 -18.989,29.787 -38.026,45.112c-33.738,27.158 -70.049,24.494 -86.085,21.637l-0.326,-0.058c-0.755,-0.135 -1.463,-0.27 -2.122,-0.402c5.092,4.813 11.148,12.276 16.29,23.483c6.495,14.155 7.503,39.078 3.832,57.674c-3.433,17.389 -8.764,34.764 -10.429,40.867c-3.046,11.171 -22.923,62.091 -19.479,94.577c0.834,7.864 2.474,12.033 5.035,15.359l-115.578,-0c1.266,-5.369 2.477,-10.08 3.574,-13.988c3.954,-14.076 9.731,-29.32 15.296,-42.539c2.962,-7.973 6.414,-15.752 8.569,-22.001c4.086,-11.843 16.741,-39.315 20.956,-61.945c3.728,-20.019 7.296,-38.94 2.592,-52.852c-17.429,10.731 -49.158,24.885 -96.767,26.389c-33.535,1.06 -64.092,-5.918 -89.003,-19.094l-0.415,-0.218Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "naso",
					d: "M60.518,121.204c-3.846,14.354 -12.028,38.884 -23.844,57.006c-18.469,-16.294 -31.056,-37.372 -36.126,-61.21l59.97,4.204Z",
					style: { fill: "#e5004f" }
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "_Linear2",
				x1: 0,
				y1: 0,
				x2: 1,
				y2: 0,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(1.24538e-14,-203.386,203.386,1.24538e-14,397.601,266.671)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					style: {
						stopColor: "#0068b4",
						stopOpacity: 1
					}
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					style: {
						stopColor: "#2aa1eb",
						stopOpacity: 1
					}
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "_Linear3",
				x1: 0,
				y1: 0,
				x2: 1,
				y2: 0,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(1.24538e-14,-203.386,203.386,1.24538e-14,397.601,266.671)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					style: {
						stopColor: "#0068b4",
						stopOpacity: 1
					}
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					style: {
						stopColor: "#2aa1eb",
						stopOpacity: 1
					}
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "_Linear4",
				x1: 0,
				y1: 0,
				x2: 1,
				y2: 0,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(1.24538e-14,-203.386,203.386,1.24538e-14,397.601,266.671)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					style: {
						stopColor: "#0068b4",
						stopOpacity: 1
					}
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					style: {
						stopColor: "#2aa1eb",
						stopOpacity: 1
					}
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "_Linear5",
				x1: 0,
				y1: 0,
				x2: 1,
				y2: 0,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(1.24538e-14,-203.386,203.386,1.24538e-14,397.601,266.671)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					style: {
						stopColor: "#0068b4",
						stopOpacity: 1
					}
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					style: {
						stopColor: "#2aa1eb",
						stopOpacity: 1
					}
				})]
			})
		] })
	]
});
export default SvgFilegrantLogo;
